import { render, staticRenderFns } from "./AtomInput.vue?vue&type=template&id=10471e98&scoped=true&"
import script from "./AtomInput.vue?vue&type=script&lang=js&"
export * from "./AtomInput.vue?vue&type=script&lang=js&"
import style0 from "./AtomInput.vue?vue&type=style&index=0&id=10471e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10471e98",
  null
  
)

export default component.exports